const GdprConditionals = require('@trimm/gdpr-conditionals');

window.GdprConditionals = GdprConditionals;
window.gdpr = new GdprConditionals.init({dispatchEventsOnDOMContentLoaded: false, cookieExpires: 365 * 2});
